import React from "react";

const PRIVACY = `Welljio respects your privacy. We collect only the information needed to process your orders, deliver products, and provide smart wellness guidance. We never sell your data. You may request data deletion at any time by emailing support@welljio.com.`;
const TERMS = `By using welljio.com you agree to our terms. Products are intended to support comfort and wellness — they are not a substitute for medical care. Please consult your physician for serious or persistent symptoms.`;

export function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="max-w-3xl mx-auto px-6 py-12">
      <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">Policies</p>
      <h1 className="font-heading text-5xl font-bold tracking-tight mb-6">Privacy Policy</h1>
      <p className="text-welljio-muted leading-relaxed">{PRIVACY}</p>
    </div>
  );
}

export function TermsPage() {
  return (
    <div data-testid="terms-page" className="max-w-3xl mx-auto px-6 py-12">
      <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">Policies</p>
      <h1 className="font-heading text-5xl font-bold tracking-tight mb-6">Terms & Conditions</h1>
      <p className="text-welljio-muted leading-relaxed">{TERMS}</p>
    </div>
  );
}
